import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import ClipboardIcon from '@atlaskit/icon/core/clipboard';

import { useShareContextCopyPromptAction } from './useShareContextCopyPromptAction.ts';

const i18n = defineMessages({
	copyPrompt: {
		id: 'byline-connections.share-context-menu.copy-prompt',
		defaultMessage: 'Copy as prompt',
		description:
			'Item in the "Share with agent" menu that copies a prompt carrying this page’s context, for pasting into an AI tool the menu does not link to.',
	},
});

export type ShareContextCopyPromptItemProps = {
	prompt: string;
};

/** Copies the same prompt the deep links carry, for surfaces the menu does not link to. */
export function ShareContextCopyPromptItem({
	prompt,
}: ShareContextCopyPromptItemProps): React.JSX.Element {
	const { formatMessage } = useIntl();

	const handleClick = useShareContextCopyPromptAction(prompt);

	return (
		<DropdownItem
			elemBefore={<ClipboardIcon label="" />}
			onClick={handleClick}
			testId="share-context-menu-copy-prompt"
		>
			{formatMessage(i18n.copyPrompt)}
		</DropdownItem>
	);
}
